import { FeatureFlag } from './feature-flag';
import { FeatureFlagConfig } from './feature-flag-config';
import { injectable } from 'inversify';

@injectable()
export class FeatureFlagsLoader {
    private config?: {[key: string]: FeatureFlagConfig};

    public constructor(featureFlagsConfig?: {[key: string]: FeatureFlagConfig}) {
        this.config = featureFlagsConfig;
    }

    public get(flagName: string): FeatureFlag {
        let config;

        if (this.config && typeof this?.config?.[flagName] as unknown === 'object') {
            config = this.config[flagName];
        }

        return new FeatureFlag(config);
    }
}
